import {CSSProperties, FC} from 'react';
import {Select, Space} from 'antd';

interface CustomSelectOptions {
	data: Array<{value: string | number; label: string}>;
	handleChange: (value: string | number) => void;
	props?: CSSProperties;
}

export const CustomSelect: FC<CustomSelectOptions> = ({data, handleChange, props}) => {
	return (
		<Space wrap>
			<Select
				defaultValue={data[0]?.label}
				style={{width: '100%', ...props}}
				onChange={handleChange}
				options={data}
			/>
		</Space>
	);
};
